"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ALL_L1_CATEGORIES_AND_TERMINAL_NODES_FOR_STRATEGY_MATRIX = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_ALL_L1_CATEGORIES_AND_TERMINAL_NODES_FOR_STRATEGY_MATRIX = (0, gql_1.gql)(`
  query GetAllL1CategoriesAndTerminalNodes($productTreeNodeId: ID!,
   $filter: ProductTreeNodeDescendantFilter,
    $first: Int,
    $sort: [ProductTreeNodeRelativeOrderBy!],
    # $catalog: ID!
  ) {
    productTreeNode(id: $productTreeNodeId) {
      id
      children {
        title
        id
        descendants(filter: $filter, first: $first, sort: $sort) {
          edges {
            node {
              descendant {
                id
                title
                #   productPresentationsNew(catalog: $catalog) {
                #     totalCount
                # }
              }
            }
          }
          totalCount
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
        }
      }
    }
  }
`);
